import { FC } from 'react';
import { Link, LinkProps, useLocation } from 'react-router-dom';
import { getFullPath } from '../../utilities';

// Extends from main `LinkProps` so we can pass any of their props to this component.
interface CustomRouterLinkProps extends LinkProps {
  /**
   * A `string` representing the route that this link should redirect to.
   * Internally it's converted to a `To` from `react-router-dom`
   * to avoid losing search params, query params, or hash.
   */
  to: string;
  /**
   * The label to render inside the anchor element.
   */
  label: string;
  /**
   * A CSS class that's added to the parent `li` element.
   */
  parentClassName?: string;
}

export const CustomRouterLink: FC<CustomRouterLinkProps> = ({
  to,
  label,
  parentClassName = 'nav-button',
  ...rest
}: CustomRouterLinkProps) => {
  const { pathname } = useLocation();

  /**
   * Get the active className based on the current `pathname`.
   * @returns `active` if the `to` prop matches with `pathname` or an empty string otherwise.
   */
  const getActiveClass = (): string => {
    // By splitting `pathname` and checking if we get more than one splitted item
    // should suffice for now, we could do something more complex like a RegExp
    // if we need something more robust in the future.
    return pathname.split(to).length > 1 ? 'active' : '';
  };

  return (
    <li className={`${parentClassName} ${getActiveClass()}`}>
      <Link to={getFullPath(to)} {...rest}>{label}</Link>
    </li>
  );
};

export default CustomRouterLink;
